import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const ProductLabel = lazy(() => import('../Pages/ProductLabel'));

// Import CSS
import '../Assets/css/product.scss';

function ProductLabelRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/stock/products-label"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <ProductLabel history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  );
};

export default ProductLabelRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
